// extracted by mini-css-extract-plugin
export default {"btn":"Login_btn__x7t+f","label":"Login_label__zlJQ-","input":"Login_input__ADhfa","wcblogo":"Login_wcblogo__wC5Zq","wcblogo50":"Login_wcblogo50__DzNan"};